import { FC, useMemo } from 'react'
import { Stack, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'

import { DASHBOARD_MENU, NAVIGATION_MENU_ICON } from '@/constants.ts'
import { NavigationPageRow } from '@/layouts/dashboard/navigation-panel/navigation-page-row.tsx'
import { UserPermissions } from '@/types.ts'
import { useUser } from '@/stores/slices/user-slice.ts'

export const sbpFolder: (keyof UserPermissions)[] = ['showSbp', 'showB2c', 'showQrC2b', 'showQrB2b']
export const acqFolder: (keyof UserPermissions)[] = ['showAcqOperations', 'showOneTimePage', 'showStaticTemplate']

type NavigationFolderType = {
  titleFolder: string
  permissionsKey: (keyof UserPermissions)[]
}

export const NavigationFolder: FC<NavigationFolderType> = ({ titleFolder, permissionsKey }) => {
  const location = useLocation()
  const user = useUser()

  const permissionSetting = useMemo(() => {
    if (!user?.id) return {} as UserPermissions

    const allPermissions = { ...user.permissions }

    for (const key in user.permissions) {
      if (!permissionsKey.includes(key as keyof UserPermissions)) {
        allPermissions[key as keyof UserPermissions] = false
      }
    }

    return allPermissions
  }, [user])

  const userMenu = DASHBOARD_MENU(permissionSetting)

  if (userMenu.length <= 0) return null

  return (
    <Stack flexDirection="column" sx={{ gap: '4px' }}>
      <Typography variant="subtitle1" color="subtitle.primary" sx={{ padding: '8px 16px' }}>
        {titleFolder}
      </Typography>
      {userMenu.map((e) => (
        <NavigationPageRow
          key={e.href}
          title={e.title}
          href={e.href}
          iconName={NAVIGATION_MENU_ICON[e.href]}
          isActive={location.pathname.includes(e.href)}
        />
      ))}
    </Stack>
  )
}
